import { render } from "./result.vue?vue&type=template&id=3690dc1c"
import script from "./result.vue?vue&type=script&lang=js"
export * from "./result.vue?vue&type=script&lang=js"

import "./result.vue?vue&type=style&index=0&id=3690dc1c&lang=less"
script.render = render

export default script